import { render, staticRenderFns } from "./WaterTankHygieneCheck.vue?vue&type=template&id=20ae2e9b&scoped=true&"
import script from "./WaterTankHygieneCheck.vue?vue&type=script&lang=js&"
export * from "./WaterTankHygieneCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ae2e9b",
  null
  
)

export default component.exports